import styled from "styled-components";
export const StepGraphicContainer = styled.div `
  display: flex;
  flex-direction: column;
  grid-column: 1;
  grid-row: 1;
  justify-content: flex-start;
  max-width: 48px;
  padding: 8px 0 0;
  width: 100%;
`;
//# sourceMappingURL=styled.js.map